import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl, Validators, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import {PredefinedNoteDataModel} from '../../../../models/notes/predefined-note-data.model';

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({ 
  selector: 'app-note-builder-context',
  templateUrl: './note-builder-context.component.html',
  styleUrls: ['./note-builder-context.component.css']
})
export class NoteBuilderContextComponent implements OnInit {
  @Input() positionX = 0;
  @Input() positionY = 0;
  @Input() actionsDisabled: boolean = false;
  @Input() allowEditOptions: boolean = false;
  @Input() dataPredefinedNote: PredefinedNoteDataModel;

  @Output() edit = new EventEmitter<boolean>();
  @Output() addNew = new EventEmitter<boolean>();
  @Output() delete = new EventEmitter<boolean>();
  @Output() addSeperator = new EventEmitter<string>();

  addingSeparator: boolean = false;
  separatorHeader: string = '';
  headerFormControl = new UntypedFormControl('', [Validators.required]);
  matcher = new MyErrorStateMatcher();

  constructor() { }

  ngOnInit() {
  }

  emitAddNew() {
    this.addNew.emit(true);
  }

  emitDelete() {
    this.delete.emit(true);
  }

  emitAddSeperator() {
    if (this.separatorHeader.trim() === '') {
      return;
    }

    this.addSeperator.emit(this.separatorHeader);
  }

  emitEdit() {
    this.edit.emit(true);
  }
}
